'use strict';

import { createRoot } from 'react-dom/client';
import App from 'apps/training-search';

const element = document.getElementById('app');
const algolia = {
	app_id: element.dataset.algoliaAppId,
	key: element.dataset.algoliaKey,
	index: element.dataset.algoliaIndex,
};

createRoot(element).render(<App algolia={ algolia } />);
